import React from 'react'
import './AthleteAwardsHonors.css'
import '../layout/Spinner.css'

const AthleteAwardsHonors = (props) => {

        const athleteAwardsHonors = props.athleteAwardsHonors
        
        var displayAwardsHonors = null
        var academicHonors = null
        var athleticAwards = null

        var academicHonorsExist = false
        var athleticAwardsExist = false

        if (athleteAwardsHonors) {

            if (athleteAwardsHonors.academicHonorOne && athleteAwardsHonors.academicHonorOne !== 'None') {

                academicHonorsExist = true

                academicHonors = [

                    <div className="AthleteAwardsHonorsRow" key='academicHonorOne'>
                        <p>{athleteAwardsHonors.academicHonorOne}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.academicHonorTwo && athleteAwardsHonors.academicHonorTwo !== 'None') {

                academicHonorsExist = true

                academicHonors = [
                    academicHonors,
                    <div className="AthleteAwardsHonorsRow" key='academicHonorTwo'>
                        <p>{athleteAwardsHonors.academicHonorTwo}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.academicHonorThree && athleteAwardsHonors.academicHonorThree !== 'None') {

                academicHonorsExist = true

                academicHonors = [
                    academicHonors,
                    <div className="AthleteAwardsHonorsRow" key='academicHonorThree'>
                        <p>{athleteAwardsHonors.academicHonorThree}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.academicHonorFour && athleteAwardsHonors.academicHonorFour !== 'None') {

                academicHonorsExist = true

                academicHonors = [
                    academicHonors,
                    <div className="AthleteAwardsHonorsRow" key='academicHonorFour'>
                        <p>{athleteAwardsHonors.academicHonorFour}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.academicHonorFive && athleteAwardsHonors.academicHonorFive !== 'None') {

                academicHonorsExist = true

                academicHonors = [
                    academicHonors,
                    <div className="AthleteAwardsHonorsRow" key='academicHonorFive'>
                        <p>{athleteAwardsHonors.academicHonorFive}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.academicHonorSix && athleteAwardsHonors.academicHonorSix !== 'None') {

                academicHonorsExist = true

                academicHonors = [
                    academicHonors,
                    <div className="AthleteAwardsHonorsRow" key='academicHonorSix'>
                        <p>{athleteAwardsHonors.academicHonorSix}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.academicHonorSeven && athleteAwardsHonors.academicHonorSeven !== 'None') {

                academicHonorsExist = true

                academicHonors = [
                    academicHonors,
                    <div className="AthleteAwardsHonorsRow" key='academicHonorSeven'>
                        <p>{athleteAwardsHonors.academicHonorSeven}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.academicHonorEight && athleteAwardsHonors.academicHonorEight !== 'None') {

                academicHonorsExist = true

                academicHonors = [
                    academicHonors,
                    <div className="AthleteAwardsHonorsRow" key='academicHonorEight'>
                        <p>{athleteAwardsHonors.academicHonorEight}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.academicHonorNine && athleteAwardsHonors.academicHonorNine !== 'None') {

                academicHonorsExist = true

                academicHonors = [
                    academicHonors,
                    <div className="AthleteAwardsHonorsRow" key='academicHonorNine'>
                        <p>{athleteAwardsHonors.academicHonorNine}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.academicHonorTen && athleteAwardsHonors.academicHonorTen !== 'None') {

                academicHonorsExist = true

                academicHonors = [
                    academicHonors,
                    <div className="AthleteAwardsHonorsRow" key='academicHonorTen'>
                        <p>{athleteAwardsHonors.academicHonorTen}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.athleticAwardOne && athleteAwardsHonors.athleticAwardOne !== 'None') {

                athleticAwardsExist = true

                athleticAwards = [

                    <div className="AthleteAwardsHonorsRow" key='athleticAwardOne'>
                        <p>{athleteAwardsHonors.athleticAwardOne}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.athleticAwardTwo && athleteAwardsHonors.athleticAwardTwo !== 'None') {

                athleticAwardsExist = true

                athleticAwards = [
                    athleticAwards,
                    <div className="AthleteAwardsHonorsRow" key='athleticAwardTwo'>
                        <p>{athleteAwardsHonors.athleticAwardTwo}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.athleticAwardThree && athleteAwardsHonors.athleticAwardThree !== 'None') {

                athleticAwardsExist = true

                athleticAwards = [
                    athleticAwards,
                    <div className="AthleteAwardsHonorsRow" key='athleticAwardThree'>
                        <p>{athleteAwardsHonors.athleticAwardThree}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.athleticAwardFour && athleteAwardsHonors.athleticAwardFour !== 'None') {

                athleticAwardsExist = true

                athleticAwards = [
                    athleticAwards,
                    <div className="AthleteAwardsHonorsRow" key='athleticAwardFour'>
                        <p>{athleteAwardsHonors.athleticAwardFour}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.athleticAwardFive && athleteAwardsHonors.athleticAwardFive !== 'None') {

                athleticAwardsExist = true

                athleticAwards = [
                    athleticAwards,
                    <div className="AthleteAwardsHonorsRow" key='athleticAwardFive'>
                        <p>{athleteAwardsHonors.athleticAwardFive}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.athleticAwardSix && athleteAwardsHonors.athleticAwardSix !== 'None') {

                athleticAwardsExist = true

                athleticAwards = [
                    athleticAwards,
                    <div className="AthleteAwardsHonorsRow" key='athleticAwardSix'>
                        <p>{athleteAwardsHonors.athleticAwardSix}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.athleticAwardSeven && athleteAwardsHonors.athleticAwardSeven !== 'None') {

                athleticAwardsExist = true

                athleticAwards = [
                    athleticAwards,
                    <div className="AthleteAwardsHonorsRow" key='athleticAwardSeven'>
                        <p>{athleteAwardsHonors.athleticAwardSeven}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.athleticAwardEight && athleteAwardsHonors.athleticAwardEight !== 'None') {

                athleticAwardsExist = true

                athleticAwards = [
                    athleticAwards,
                    <div className="AthleteAwardsHonorsRow" key='athleticAwardEight'>
                        <p>{athleteAwardsHonors.athleticAwardEight}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.athleticAwardNine && athleteAwardsHonors.athleticAwardNine !== 'None') {

                athleticAwardsExist = true

                athleticAwards = [
                    athleticAwards,
                    <div className="AthleteAwardsHonorsRow" key='athleticAwardNine'>
                        <p>{athleteAwardsHonors.athleticAwardNine}</p>
                    </div>
                ]   
            }
            if (athleteAwardsHonors.athleticAwardTen && athleteAwardsHonors.athleticAwardTen !== 'None') {

                athleticAwardsExist = true

                athleticAwards = [
                    athleticAwards,
                    <div className="AthleteAwardsHonorsRow" key='athleticAwardTen'>
                        <p>{athleteAwardsHonors.athleticAwardTen}</p>
                    </div>
                ]   
            }

            // if (academicHonorsExist && athleticAwardsExist) {

                displayAwardsHonors = (

                    <div className="AthleteAwardsHonorsInfoContainer">
                        {academicHonorsExist && ( <div className="AthleteAwardsHonorsGroupContainer">
                            <h3>Academic Honors</h3>
                            {academicHonors}
                        </div>) }
                       
                       {athleticAwardsExist && (<div className="AthleteAwardsHonorsGroupContainer">
                            <h3>Athletic Awards</h3>
                            {athleticAwards}
                        </div>)}
                        
                    </div>
                )

            // } else {

            //     displayAwardsHonors = null
            // }
        }

        return displayAwardsHonors
}

export default AthleteAwardsHonors